import { z } from 'zod';

export const signInFormSchema = z.object({
  email: z.string()
    .min(6, { message: 'This field is required' })
    .email({
      message: 'Incorrect email',
    }),
  password: z.string()
    .min(8, { message: 'Password must be at least 8 characters long' })
    .regex(/[0-9]/, { message: 'Password must contain at least one number' }),
});
